import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "~/components/ui";
import { type FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { useReferenceDocs } from "@noa/client-store";
import { useIsRefDocsPanelCollapsed, useToggleRefDocsPanelCollapse } from "~/store/ui-preferences.store";
import { ReferenceDocumentsHeader } from "./reference-documents-header";
import { ReferenceDocumentsList } from "./reference-documents-list";

interface ReferenceDocumentsProps {
  className?: string;
}

export const ReferenceDocuments: FunctionComponent<ReferenceDocumentsProps> = ({ className }) => {
  const { t } = useTranslation();
  const { documents, referenceMap } = useReferenceDocs();

  const isCollapsed = useIsRefDocsPanelCollapsed();
  const toggleCollapse = useToggleRefDocsPanelCollapse();

  return (
    <div className={cn("relative flex h-full", className)}>
      <div
        className={cn(
          "flex h-full flex-col overflow-hidden border-l border-noa bg-noa",
          isCollapsed ? "w-0" : "w-[360px]"
        )}
      >
        {!isCollapsed && (
          <>
            <ReferenceDocumentsHeader />
            <ReferenceDocumentsList documents={documents} referenceMap={referenceMap} />
          </>
        )}
      </div>

      <Button
        variant="text"
        shape="circle"
        size="small"
        title={isCollapsed ? t("referenceDocs:showDocuments") : t("referenceDocs:hideDocuments")}
        icon={isCollapsed ? <ChevronLeft size={12} /> : <ChevronRight size={12} />}
        onClick={() => toggleCollapse()}
        className="absolute -left-4 top-1/2 border border-noa bg-noa text-xs"
      />
    </div>
  );
};
